import { proxy } from "valtio";

const baseEventCounts = {
  CONTENT_LOADED: 0,
} as const;

type BaseEventKeys = keyof typeof baseEventCounts;

export const contentCatalogEvents = proxy({
  ...baseEventCounts,
  send_event(this: any, key: BaseEventKeys) {
    this[key] += 1;
    console.log(key, "is now", this[key]);
  },
});
